import { ReactElement } from 'react';
import { Nullable } from '../../../../../../models';
import * as S from './emailSuggestion.styled';
import { EmailSuggestionModel } from './emailSuggestion.model';
import { useTranslations } from '../../../../../translations';

export const EmailSuggestion = ({
  values,
  handleSuggestionClick,
}: EmailSuggestionModel): Nullable<ReactElement> => {
  const translations = useTranslations();

  if (!values) {
    return null;
  }

  return (
    <S.EmailSuggestion>
      Возможно, вы хотели указать{' '}
      {values.map((value, index) => (
        <>
          {index !== 0 && ` ${translations.or} `}
          <S.EmailSuggestionValue
            key={value}
            onClick={handleSuggestionClick.bind(null, value)}
          >
            {value}
          </S.EmailSuggestionValue>
        </>
      ))}
    </S.EmailSuggestion>
  );
};
